import { render, staticRenderFns } from "./LoginFrame.vue?vue&type=template&id=a240cc4e"
import script from "./LoginFrame.vue?vue&type=script&lang=js"
export * from "./LoginFrame.vue?vue&type=script&lang=js"
import style0 from "./LoginFrame.vue?vue&type=style&index=0&id=a240cc4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports